import React, { useEffect } from "react";

// Common Components
import Footer from "../../common/footer";
import Faq from "../faq";
import Navbar from "../../common/navbar/mainnavbar";

// Images
import Service1 from "../../assets/img/service-img/dairy-img-1.png";
import Service2 from "../../assets/img/service-img/dairy-img-2.png";
import Service3 from "../../assets/img/service-img/dairy-img-3.png";
import Service4 from "../../assets/img/service-img/dairy-img-4.png";
import Header from "../../common/Header/header";
import { useLocation } from "react-router-dom";

// Json Role

// FAQ Json
const DairyFaq = [
  {
    question: "1. What are dairy farm management services?",
    answer:
      "A range of expert solutions are included in dairy farm management services with the goal of maximizing the sustainability, efficiency, and productivity of dairy operations. Herd health management, nutrition planning, facility design, milk production optimization, and financial management are a few examples of these services.",
  },
  {
    question: "2. Why are dairy farm management services important?",
    answer: "Sustaining sustainable farming practices, guaranteeing animal welfare, and optimizing profitability all depend on efficient dairy farm management. Expert consulting services assist farmers in overcoming difficult obstacles, putting best practices into action, and adjusting to shifting market conditions—all of which contribute to long-term success.",
  },
  {
    question: "3. How can dairy farm management services benefit my farm?",
    answer: "There are many advantages to using dairy farm management services, such as better herd health, more milk produced, optimum feed efficiency, lower operating expenses, increased regulatory compliance, and higher farm profitability overall. These services can also offer insightful information and assistance with long-term strategic planning and expansion.",
  },
  {
    question: "4. What types of dairy farm management services do you offer?",
    answer: "We provide comprehensive dairy farm management services that are customized to each farm's unique requirements. Our areas of competence include staff training, financial analysis, facility design and maintenance, nutrition analysis, reproductive management, and herd health monitoring.",
  },
  {
    question:
      "5. How do I know if my dairy farm needs professional management services?",
    answer: "Hiring a professional consultant may be helpful if you're dealing with concerns like decreasing milk production, excessive feed expenses, animal health problems, inefficient operations, or problems with regulatory compliance. Additionally, seeking the advice and assistance of professionals can be quite beneficial if you're hoping to grow your business, increase profitability, or improve efficiency.",
  },
  {
    question:
      "6. Can dairy farm management services help with sustainability and environmental stewardship?",
    answer: "Definitely, yes. Our consulting services have a strong emphasis on sustainable dairy production methods. We can assist you in putting plans into action that will lessen your impact on the environment, increase resource efficiency, and improve animal welfare while keeping or boosting profitability.",
  },
  {
    question: "7. How do I get started with dairy farm management services?",
    answer: "It's simple to get going. To arrange a consultation, just get in contact with our staff. Together, we will evaluate the particular requirements, objectives, and difficulties of your farm and create a personalized action plan. We are here to help you every step of the way, whether you run a huge commercial enterprise or a small family farm.",
  },
];

const DairyConsultantService = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // slight delay to ensure element is mounted
      }
    }
  }, [location]);
  return (
    <>
      <Navbar />
      <div className="service-bg-color products" id="Service">
        {/* <div className="pt-lg-4 mt-n1">
          <Header title="Services" link="/" subtitle="Dairy Consultant Service" />
        </div> */}
        <div className="container pt-lg-5">
          <div className="text-center">
            <p className="service-heading">
              Dairy Consultant Services by Rumeno Farmotech
            </p>
            <p className="heading-description">
              Ruminant Herd Management is an important factor for Dairy farms
              that maintain long-term high production. They need to successfully
              manage several key factors: nutrition, reproduction, comfort, and
              milking. Alongside these essentials, all dairy farms must deal
              with the logistics of weather, transportation, and expenses. It
              can be a lot to balance, but proper planning and thoughtful
              utilization of the latest dairy farm training and technology make
              it possible..
            </p>
          </div>
          <div className="row my-5 g-0 bg-white service-border">
            <div className="col-lg-6 ">
              <img
                src={Service1}
                className="dairy-img img-fluid w-100"
                alt="Loading"
              />
            </div>
            <div className="col-lg-6 px-5 p-4 d-flex">
              <div className="">
                <p className="content-heading">
                  Helping You Achieve Better Dairy Productivity with
                  Professional Consulting Services
                </p>
                <p className="service-inner-text">
                  As your trusted dairy consultant partner, Rumeno Farmotech
                  goes beyond just selling products. Our expert consultants
                  offer in-depth analysis of your farm's specific needs and
                  goals. We develop customized plans to optimize milk
                  production, ensure herd health and well-being, and maximize
                  your farm's profitability. By leveraging state-of-the-art
                  technologies and our team's experience, Rumeno Farmotech
                  empowers you to make informed decisions and achieve long-term
                  success in the dairy industry.
                </p>
                <p className="service-inner-text">
                  Dairy farming is a key component of contemporary agriculture,
                  feeding millions of people and propelling global economies.
                  But the intricacies of effectively running a dairy farm demand
                  knowledge above the rudimentary levels. In order to fulfill
                  the changing needs of the business, Rumeno Farmotech provides
                  full dairy farm management services as well as livestock
                  consultancy solutions.
                </p>
              </div>
            </div>
          </div>

          <div className="row my-5 g-0 bg-white service-border scroll-section" id="DairyManagement">
            {/* secong img */}
            <div className="col-lg-7 py-4  px-5">
              <div className="">
                <p className="content-heading">
                  Understanding Dairy Farm Management Services
                </p>
                <p className="service-inner-text">
                  The wide range of duties included in dairy farm management
                  services are essential to the efficient running and highest
                  level of output of a dairy farm. With a comprehensive approach
                  focused on optimizing efficiency and profitability, Rumeno
                  Farmotech offers everything from feed optimization to herd
                  health management.{" "}
                </p>

                <p className="service-inner-text">
                  Rumeno Farmotech's experience allows dairy producers to have
                  access to industry best practices and state-of-the-art
                  technologies. Our consultants work closely with farmers to
                  improve productivity and streamline processes, whether it's
                  installing automated milking equipment or creating
                  individualized feeding plans for cattle.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <img
                src={Service2}
                className="dairy-img img-fluid w-100"
                alt="Loading"
              />
            </div>
          </div>

          <div className="row my-5 g-0 bg-white service-border">
            {/* Third img */}
            <div className="col-lg-6">
              <img
                src={Service3}
                className="dairy-img img-fluid w-100"
                alt="Loading"
              />
            </div>
            <div className="col-lg-6 p-5">
              <div className="">
                <p className="content-heading">
                  Resolve dairy problems with our dairy consulting services
                </p>

                <p className="service-inner-text">
                  Dairy consulting services are extremely important because
                  dairy farmers encounter a broad variety of problems. The
                  advisors at Rumeno Farmotech, comprising experienced
                  professionals, are unmatched in competence and innovation and
                  create strategies to breach the barrier against their
                  competitors in the dairy market. <br />
                  Dairy farming is approached with fact-based techniques in
                  every segment - controlling diseases or strategic breeding
                  plans under our consultants to improve the health and
                  performance of cattle. Holistic assessments and individual
                  solutions guarantee that dairy farmers are not one step behind
                  anybody. <br />
                  We care about the welfare of the dairy herd and aim to reach
                  maximum profitability by equipping the tool and knowledge to
                  the farmer for survival in the long run.
                </p>
              </div>
            </div>
          </div>

          <div className="row my-5 g-0 bg-white service-border">
            {/* Fourth img */}
            <div className="col-lg-9 px-5 py-4">
              <div className="">
                <p className="content-heading">
                  Empowering Dairy Farmers With Our Dairy Farming Consultancy
                </p>

                <p className="service-inner-text">
                  The mission is to equip dairy producers with the skill and
                  equipment required for success in business operations As the
                  nation's leading dairy consultants, we offer all the dairy
                  farm management and livestock consulting services. We are
                  consults and more; we look forward to being dependable
                  partners in your journey to excellence in agriculture. The
                  primary goal of Rumeno Farmotech is to provide dairy producers
                  with the skills and tools they need to be successful. We
                  aspire to be more than just consultants with our full range of
                  dairy farm management and livestock consulting services; we
                  want to be dependable partners on the path to agricultural
                  greatness. <br />
                  Rumeno Farmotech supports sustainable methods and the most
                  recent technological developments to help dairy producers
                  maximize their operations for long-term success. Whether it's
                  increasing the productivity of milk production or encouraging
                  environmental stewardship, our solutions are meant to produce
                  measurable effects and lead to favorable outcomes for farmers
                  and their communities. The demand for professional advice and
                  assistance in the constantly changing field of dairy farming
                  has never been higher. Leading this change in Rumeno
                  Farmotech, which provides solutions for livestock consultancy
                  and dairy farm management that are unmatched in the industry.{" "}
                  <br />
                  With collaboration, innovation, and the very strong commitment
                  to excellence for Rumeno Farmotech and dairy farmers, real
                  challenges can be overcome, opportunities identified, and room
                  paved toward a brighter future for dairy farming. <br />
                  Contact Rumeno Farmotech now for more information about its
                  Dairy Farming Consultancy and embark on a trip along the
                  roadmap of sustainable and transformative development in dairy
                  farming. Let's create a new future for agriculture, one farm
                  at a time.
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <img
                src={Service4}
                className="dairy-img img-fluid w-100"
                alt="Loading"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Faq Section Start */}
      <div className="bg-white">
        <div className="container">
          <Faq faqs={DairyFaq} showHeading={false} />
        </div>
      </div>

      {/* Footer Section Start */}
      <Footer />
    </>
  );
};

export default DairyConsultantService;
